<template>
  <div class="row myrow content-mb-42">
    <div class="col-xs-12 mycol">
      <table class="c-indicator c-indicator-w-100">
        <TableHeadAddDZ :document-conf="documentConf"></TableHeadAddDZ>
        <tbody>
          <TableRowAddDZ
            v-for="(doc, docIndex) in docs"
            :key="doc.TYPE_ID || index + '.' + docIndex"
            :index="index"
            :doc-index="docIndex"
            :doc="doc"
            :docsType="docs"
            :document-conf="documentConf"
            :document-history="documentHistory"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import TableHeadAddDZ from "@/components/project/documents/TableHeadAddDZ";
import TableRowAddDZ from "@/components/project/documents/TableRowAddDZ";
import UploadRowAddDZ from "@/components/project/documents/UploadRowAddDZ";

export default {
  components: { UploadRowAddDZ, TableRowAddDZ, TableHeadAddDZ },
  props: ["docs", "documentConf", "index", "project", "documentHistory"],
  name: "DocumentTableAddDZ"
};
</script>

<style scoped></style>
